import React, { useMemo } from "react";

// Assuming you have image imports for consumer profiles
import {
  testimonial11,
  testimonial12,
  testimonial13,
  testimonial14,
  testimonial15,
  testimonial16,
  testimonial17,
  testimonial18,
  testimonial19,
  testimonial20,
} from "../../../assets/data/Imagedata";
import { FaStar } from "react-icons/fa";

// Star Icon for rating
const StarIcon = () => (
 <FaStar className="text-yellow-500"/>
);

// New component name reflecting the content
const ConsumerReviews = () => {
  // Define the data structure for the reviews using the provided order
  const reviewsData = useMemo(
    () => [
      {
        name: "Rajesh Sharma",
        location: "Delhi",
        review:
          "I was sold a defective laptop and the retailer refused to replace it. The CRC's website provided a clear guide on how to file a formal complaint. Their resources helped me understand my rights as a consumer and I was finally able to get a replacement. Their support was invaluable.",
        image: testimonial11,
        rating: 5,
      },
      {
        name: "Lakshmi Narayanan",
        location: "Chennai",
        review:
          "I was confused by a misleading service contract for my internet connection and was being overcharged. I called the CRC helpline and they provided me with clear, practical advice on how to dispute the charges. Thanks to their guidance, I was able to get the extra charges reversed.",
        image: testimonial12,
        rating: 4,
      },
      {
        name: "Vikram Das",
        location: "Kolkata",
        review:
          "I was scammed by an online seller and thought I had lost my money forever. The CRC's website had a comprehensive guide on reporting online fraud. Following their steps, I filed a complaint with the right authorities and eventually got my money back. I am very grateful for their help.",
        image: testimonial13,
        rating: 5,
      },
      {
        name: "Priya Patel",
        location: "Mumbai",
        review:
          "I had a long-standing dispute with my electricity provider over excessive billing that they wouldn't resolve. The CRC's intervention was key. They helped me escalate the matter to the appropriate forum, and their support made a huge difference in finally getting the issue sorted out.",
        image: testimonial14,
        rating: 4,
      },
      {
        name: "Suresh Kumar",
        location: "Indore",
        review:
          "As a small farmer, I was devastated when I was sold poor-quality seeds that ruined my crop. I didn't know where to turn for help. The CRC's local representative was very helpful. They guided me on how to file a complaint and I was able to get some compensation for my loss.",
        image: testimonial15,
        rating: 5,
      },
      {
        name: "Meera Devi",
        location: "Bangalore",
        review:
          "An airline unfairly denied me a refund for a flight they cancelled at the last minute. The CRC's website has excellent resources on airline passenger rights in India. This information gave me the confidence to challenge the airline's decision, and I was ultimately able to get my refund.",
        image: testimonial16,
        rating: 4,
      },
      {
        name: "Col. (Retd.) Anil Singh",
        location: "Chandigarh",
        review:
          "When my health insurance claim was wrongfully denied, I felt helpless. The CRC provided me with legal precedents and the necessary information to file a strong appeal. Their guidance was instrumental in getting the insurance company to reverse their decision and approve my claim.",
        image: testimonial17,
        rating: 5,
      },
      {
        name: "Karthik Reddy",
        location: "Visakhapatnam",
        review:
          "After a major data breach at a telecom company, I was very concerned about the privacy of my personal information. The CRC's advocacy and clear communication helped me understand the steps I needed to take to protect myself. Their proactive approach to consumer data privacy is very reassuring.",
        image: testimonial18,
        rating: 4,
      },
      {
        name: "Anjali Mishra",
        location: "Bhubaneswar",
        review:
          "I was very worried when I discovered adulterated spices in a product I bought. I didn't know how to report it. The CRC's website was a great resource, guiding me to the right food safety authorities. My complaint led to an inspection, and I am thankful for their role in ensuring food safety.",
        image: testimonial19,
        rating: 5,
      },
      {
        name: "Rohan Shah",
        location: "Hyderabad",
        review:
          "As a young entrepreneur, my startup was misled by a software vendor's false advertising. The CRC's resources on unfair trade practices were a game-changer for us. They helped us build a strong case and negotiate a fair settlement, saving our business a lot of money and time.",
        image: testimonial20,
        rating: 5,
      },
    ],
    []
  );

  // Function to render the correct number of star icons
  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const starArray = [];
    for (let i = 0; i < fullStars; i++) {
      starArray.push(<StarIcon key={i} className="w-5 h-5 text-yellow-500" />);
    }
    // Optional: Add half star or empty stars for visual accuracy if needed
    return starArray;
  };

  return (
    <section className="py-16 bg-gray-50 sm:py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <h2 className="text-4xl font-extrabold tracking-tight text-gray-900 text-center mb-16">
          Consumer Success Stories
        </h2>

        {/*
          Grid Container:
          - grid-cols-1: Mobile (1 profile per row)
          - md:grid-cols-2: Medium screen and up (2 profiles per row)
          - gap-12: Ample space between the profiles
        */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-12">
          {reviewsData.map((profile, index) => (
            <div
              key={index}
              className="group flex flex-col bg-white border border-gray-200 rounded-xl shadow-lg 
                p-6 sm:p-8 transition-all duration-300 hover:shadow-xl"
              tabIndex={0}
            >
              
              {/* Review Quote / Description */}
              <p className="text-gray-700 leading-relaxed italic mb-6 text-lg">
                "{profile.review}"
              </p>
              
              {/* Separator */}
              <div className="w-full border-t border-gray-100 mb-6" />

              {/* Profile/Source Details (Aligned horizontally below review) */}
              <div className="flex items-start">
                
                {/* Image */}
                <div className="w-16 h-16 flex-shrink-0 mr-4 rounded-full overflow-hidden border-2 border-indigo-500 shadow-md">
                  <img
                    src={profile.image}
                    alt={`Profile of ${profile.name}`}
                    className="w-full h-full object-cover object-center"
                    loading="lazy"
                  />
                </div>

                {/* Name, Location, and Rating */}
                <div className="flex flex-col">
                  <p className="text-xl font-semibold text-gray-900">
                    {profile.name}
                  </p>
                  <p className="text-sm text-indigo-600 mb-2">
                    {profile.location}
                  </p>
                  
                  {/* Rating Stars */}
                  <div className="flex items-center space-x-0.5">
                    {/* Render the stars dynamically */}
                    {renderStars(profile.rating)}
                    <span className="ml-2 text-sm text-gray-500">
                        {profile.rating}/5
                    </span>
                  </div>
                </div>
              </div>

            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ConsumerReviews;